<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() || 'Notifications' }}</h2>
            <p>All admin alerts — KYC submissions and other events awaiting your attention.</p>
        </div>
        <p-button label="Mark all read" icon="pi pi-check" [outlined]="true"
            [disabled]="!unreadCount" (onClick)="markAllRead()" />
    </div>

    <div class="card">
        <div class="toolbar">
            <div class="filter">
                <label>Show</label>
                <p-select [ngModel]="filter()" (ngModelChange)="onFilter($event)" [options]="filterOptions"
                    optionLabel="label" optionValue="value" appendTo="body" />
            </div>
            <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary"
                pTooltip="Refresh" (onClick)="load()" [loading]="loading()" />
            <span class="count">{{ unreadCount }} unread · {{ rows().length }} total</span>
        </div>

        <p-table [value]="rows()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="rows().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>Notification</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Received</th>
                    <th class="ta-r">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-n>
                <tr [class.unread-row]="!n.isRead">
                    <td class="note-cell">
                        <span class="note-title">{{ n.title || 'Notification' }}</span>
                        <span class="note-msg">{{ n.message }}</span>
                    </td>
                    <td><span class="mono">{{ n.type }}</span></td>
                    <td>
                        <p-tag [value]="n.isRead ? 'Read' : 'Unread'"
                            [severity]="n.isRead ? 'secondary' : 'info'" />
                    </td>
                    <td>{{ n.createdDate | indDate: true }}</td>
                    <td class="ta-r actions">
                        @if (!n.isRead) {
                        <p-button icon="pi pi-check" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Mark read" (onClick)="markRead(n)" />
                        }
                        @if (n.refId != null) {
                        <p-button icon="pi pi-arrow-up-right" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Open" (onClick)="open(n)" />
                        }
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5">
                        <div class="state"><i class="pi pi-inbox"></i>
                            <p>No notifications to show.</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
